import SMSP from '@/assets/images/smsf.png';

import styles from './index.module.scss';
export const Phone = () => {
  return <img src={SMSP} alt="SMSP" className={styles.smsP} />;
};
